// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"88867a64","156":"9ade5de5","224":"e938d973","314":"be61efdf","591":"454177fb","682":"f8e31e09","825":"1ed8a83a","828":"7dfe2561"}[chunkId] + ".chunk.js";
};